'use strict';

module.exports = require('./ReactRevealText').default;


//////////////////
// WEBPACK FOOTER
// ./~/react-reveal-text/lib/index.js
// module id = 1068
// module chunks = 263063586409284